import { CheckCircle, CreditCard, Loader2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Button } from "../../../../../../components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../../../../components/ui/card";
import axios from "axios";
import { BaseUrlApi, ErrorMessage } from "../../../../../../lib/api";
import { toast } from "sonner";
import { Separator } from "src/components/ui/separator";
import { Input } from "../../../../../../components/ui/input";
import { cn } from "../../../../../../lib/utils";
import dayjs from "dayjs";
import { Spin } from "antd";
import { useAuth } from "../../../../../../context/AuthContext";
import { useLanguage } from "../../../../../../context/LanguageContext";

export default function BookingStep({
  course,
  selectedTeacher,
  selectedDate,
  selectedSlots,
  selectedPrice,
  selectedLevel,
  resetBooking,
  setCurrentStep,
  setShowEnrollment,
}) {
  const { user } = useAuth();
  const { language } = useLanguage();

  const [bookingLoading, setBookingLoading] = useState(false);
  const [bookingError, setBookingError] = useState(null);
  const [bookingSuccess, setBookingSuccess] = useState(false);
  const [bookingReference, setBookingReference] = useState(null);
  const [promoCode, setPromoCode] = useState("");
  const [priceAfterDiscount, setPriceAfterDiscount] = useState("");
  const [selectedPayment, setSelectedPayment] = useState(
    localStorage.getItem("selectedPayment") || null
  );
  const [promocodeID, setPromocodeID] = useState(null);

  useEffect(() => {
    localStorage.setItem("selectedPayment", selectedPayment);
  }, [selectedPayment]);

  const handleConfirmBooking = async () => {
    if (
      !course ||
      !selectedTeacher ||
      !selectedSlots.length ||
      !selectedPrice ||
      !selectedLevel
    ) {
      return;
    }

    try {
      setBookingLoading(true);
      setBookingError(null);

      const bookings = selectedSlots.map((slot) => ({
        teacher_availability_id: slot.teacher_availability_id,
        start_time: slot.start_time,
        level_id: selectedLevel.id,
        date: slot.date,
      }));

      await axios.post(`${BaseUrlApi}/student-books`, bookings);

      if (priceAfterDiscount === 0) EnrollCourse(null);

      setBookingSuccess(true);
    } catch (error) {
      setBookingError("Failed to complete booking. Please try again.");
      toast("Error", { description: ErrorMessage(error) });
    } finally {
      setBookingLoading(false);
    }
  };

  const CheckPromoCode = async () => {
    try {
      setBookingLoading(true);
      setBookingError(null);

      const { data } = await axios.post(`${BaseUrlApi}/promocode/validate`, {
        code: promoCode,
        price_id: selectedPrice.bid,
      });
      setPriceAfterDiscount(+data.promocode.price_after_discount);
      setPromocodeID(data.promocode.id);
      toast("Success", { description: "Promocode is valid 🎉" });
    } catch (error) {
      toast("Error", { description: ErrorMessage(error) });
    } finally {
      setBookingLoading(false);
    }
  };

  const handlePay = async () => {
    if (
      !course ||
      !selectedTeacher ||
      !selectedSlots.length ||
      !selectedPrice ||
      !selectedLevel
    ) {
      return;
    }

    try {
      setBookingLoading(true);
      setBookingError(null);

      let APiUrl =
        selectedPayment === "myfatoorah"
          ? "payment/gateways"
          : "paypal/payment";

      const { data } = await axios.post(`${BaseUrlApi}/${APiUrl}`, {
        amount: priceAfterDiscount ? +priceAfterDiscount : +selectedPrice.price,
        currency: "USD",
      });
      window.open(data, "_self");
    } catch (error) {
      setBookingError("Failed to complete booking. Please try again.");
      toast("Error", { description: ErrorMessage(error) });
    }
    // finally {
    //   setBookingLoading(false);
    // }
  };

  useEffect(() => {
    priceAfterDiscount === 0 && setSelectedPayment(null);
  }, [priceAfterDiscount]);

  const tokenID = new URLSearchParams(window.location.search).get("tokenID");
  const PayerID = new URLSearchParams(window.location.search).get("PayerID");
  const invoiceID = new URLSearchParams(window.location.search).get(
    "invoice_id"
  );
  const payID = new URLSearchParams(window.location.search).get("id");

  const EnrollCourse = async (paymentID) => {
    try {
      await axios.post(`${BaseUrlApi}/enroll-course/create`, {
        name: course.title[language] || course.title.en || course.title.ar,
        type: selectedPrice.type === "group" ? 0 : 1,
        users_id: [user.id],
        teacher_id: selectedTeacher.user.id,
        course_id: course.id,
        level_id: selectedLevel.id,
        price_id: selectedPrice.id,
        promocode_id: promocodeID,
        payment_id: paymentID,
      });
    } catch (error) {
      setBookingError("Failed to complete booking. Please try again.");
      toast("Error", { description: ErrorMessage(error) });
    }
  };
  console.log(selectedPayment);
  const PaymentCourse = async () => {
    try {
      const { data } = await axios.post(
        `${BaseUrlApi}/student/course/payment`,
        {
          user_id: user.id,
          amount: priceAfterDiscount
            ? +priceAfterDiscount
            : +selectedPrice.price,
          status: "completed",
          [`${selectedPayment}_id`]: +payID,
        }
      );

      EnrollCourse(data.data.id);
    } catch (error) {
      setBookingError("Failed to complete booking. Please try again.");
      toast("Error", { description: ErrorMessage(error) });
    }
  };

  useEffect(() => {
    if (tokenID && PayerID) {
      axios
        .post(`${BaseUrlApi}/paypal/checkout`, {
          transaction_id: tokenID,
          account_id: PayerID,
        })
        .then(async ({ data }) => {
          toast("Success", { description: "Payment Successfully" });

          await handleConfirmBooking();
          await PaymentCourse();

          const url = new URL(window.location.href);
          url.searchParams.delete("tokenID");
          url.searchParams.delete("PayerID");
          url.searchParams.delete("id");
          window.history.replaceState(
            {},
            document.title,
            url.pathname + url.search
          );
          setBookingSuccess(true);
          setBookingReference(tokenID);
          // resetBooking()
        })
        .catch((error) => {
          setBookingError("Failed to complete booking. Please try again.");
          toast("Error", { description: ErrorMessage(error) });
          setCurrentStep(4);
          setBookingSuccess(false);
        })
        .finally(() => setBookingLoading(false));
    }
    if (invoiceID) {
      axios
        .post(`${BaseUrlApi}/payment/check`, {
          invoice_id: invoiceID,
        })
        .then(async ({ data }) => {
          toast("Success", { description: "Payment Successfully" });
          await handleConfirmBooking();
          await PaymentCourse();

          const url = new URL(window.location.href);
          url.searchParams.delete("invoice_id");
          url.searchParams.delete("id");
          window.history.replaceState(
            {},
            document.title,
            url.pathname + url.search
          );
          setBookingSuccess(true);
          setBookingReference(invoiceID);
          // resetBooking()
        })
        .catch((error) => {
          setBookingError("Failed to complete booking. Please try again.");
          toast("Error", { description: ErrorMessage(error) });
          setCurrentStep(4);
          setBookingSuccess(false);
        })
        .finally(() => setBookingLoading(false));
    }
  }, [URLSearchParams]);

  return (
    <section className="mb-16">
      <div className="flex flex-col md:flex-row items-center justify-between gap-2 flex-wrap mb-6">
        <h2 className="text-2xl font-bold">Confirm Your Booking</h2>
        {!bookingSuccess && (
          <div className="flex items-center gap-2 md:w-1/3">
            <Input
              type="search"
              placeholder="Enter promo code (optional)"
              value={promoCode}
              onChange={(e) => setPromoCode(e.target.value)}
              className="w-full"
            />
            <Button
              disabled={!promoCode || bookingLoading}
              onClick={CheckPromoCode}
            >
              {bookingLoading ? (
                <Loader2 className="ms-2 h-4 w-4 animate-spin" />
              ) : null}
              Submit
            </Button>
          </div>
        )}
      </div>

      {/* Confirm Message */}
      {(tokenID || PayerID || invoiceID) && !bookingSuccess ? (
        <div className="fixed inset-0 flex flex-col items-center justify-center gap-2 h-screen text-2xl font-bold bg-muted/80 z-50">
          <Spin size="large" /> Processing Your Payment...
          <p className="text-muted-foreground text-sm">
            Please do not close or refresh this page.
          </p>
        </div>
      ) : null}

      {bookingSuccess ? (
        <div className="text-center py-8">
          <div className="flex justify-center mb-4">
            <CheckCircle className="h-16 w-16 text-green-500" />
          </div>
          <h2 className="text-2xl font-bold mb-2">Booking Confirmed!</h2>
          {priceAfterDiscount !== 0 && (
            <p className="text-muted-foreground mb-6">
              Booking reference: {bookingReference}
            </p>
          )}

          <div className="flex gap-4 justify-center">
            <Button
              variant="outline"
              onClick={() => {
                resetBooking();
                setShowEnrollment(false);
              }}
            >
              Book Another Session
            </Button>
          </div>
        </div>
      ) : (
        <>
          {/* Methods */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-2">Payment Method</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <button
                disabled={priceAfterDiscount === 0}
                onClick={() => setSelectedPayment("myfatoorah")}
                className={cn(
                  "flex-1 p-4 rounded-xl flex flex-col items-center justify-center gap-2 transition disabled:opacity-50",
                  selectedPayment === "myfatoorah"
                    ? "ring-2 ring-blue-600 bg-muted/80"
                    : "border "
                )}
              >
                <div className="flex items-center gap-2">
                  {Visa} {MasterCard}
                </div>
                <span className="font-medium">My Fatoorah</span>
              </button>

              <button
                disabled={priceAfterDiscount === 0}
                onClick={() => setSelectedPayment("paypal")}
                className={cn(
                  "flex-1 p-4 rounded-xl flex flex-col items-center justify-center gap-2 transition disabled:opacity-50",
                  selectedPayment === "paypal"
                    ? "ring-2 ring-blue-600  bg-muted/80"
                    : "border "
                )}
              >
                {Paypal} <span className="font-medium">Paypal</span>
              </button>
            </div>
          </div>

          {bookingError && (
            <div className="p-4 rounded-xl border border-destructive bg-destructive/40 mb-4 text-destructive-foreground">
              {bookingError}
            </div>
          )}
          {/* Booking Details */}
          <Card className="mb-6">
            <CardHeader>
              <CardTitle>Booking Details</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <h3 className="text-sm font-medium text-muted-foreground">
                    Course
                  </h3>
                  <p>{course?.title?.en || "Selected Course"}</p>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-muted-foreground">
                    Teacher
                  </h3>
                  <p>{selectedTeacher?.user?.name || "Selected Teacher"}</p>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-muted-foreground">
                    Date & Times
                  </h3>
                  <ul className="list-disc list-inside">
                    {selectedSlots.map((slot, idx) => (
                      <li key={idx}>
                        {dayjs(slot.date).format("YYYY/MM/DD")} (
                        {slot.start_time})
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <Separator />
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <h3 className="text-sm font-medium text-muted-foreground">
                    Level
                  </h3>
                  <p>{selectedLevel?.title.en || selectedLevel?.title.ar}</p>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-muted-foreground">
                    Package
                  </h3>
                  <p>{selectedPrice?.name || "Standard Package"}</p>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-muted-foreground">
                    Price
                  </h3>
                  <p className="font-bold text-lg">
                    {selectedPrice.currency?.symbol ||
                      selectedPrice.currency?.code}{" "}
                    <span
                      className={cn(
                        priceAfterDiscount || priceAfterDiscount === 0
                          ? "line-through text-muted-foreground/50"
                          : ""
                      )}
                    >
                      {selectedPrice?.price || 0}
                    </span>
                    {(priceAfterDiscount || priceAfterDiscount === 0) && " / "}
                    <span className={cn("text-green-500")}>
                      {priceAfterDiscount && priceAfterDiscount}
                    </span>
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
          {/* Message */}
          <div className="mb-6 bg-blue-50 border-blue-200 p-4 rounded-xl flex items-start gap-2">
            <CheckCircle className="min-h-6 min-w-6 text-blue-600" />
            <p className="text-blue-800">
              By confirming this booking, you agree to the terms and conditions
              of the service. Cancellations must be made at least 24 hours
              before the scheduled time.
            </p>
          </div>
          {/* Navigate */}
          <div className="mt-6 flex justify-between">
            <Button variant="outline" onClick={() => setCurrentStep(3)}>
              Back to Pricing
            </Button>
            <Button
              onClick={
                priceAfterDiscount === 0 ? handleConfirmBooking : handlePay
              }
              disabled={
                bookingLoading || (priceAfterDiscount !== 0 && !selectedPayment)
              }
            >
              {bookingLoading ? (
                <Loader2 className="ms-2 h-4 w-4 animate-spin" />
              ) : null}
              Confirm and Pay
            </Button>
          </div>
        </>
      )}
    </section>
  );
}

const Paypal = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="40"
    height="40"
    viewBox="0 0 48 48"
  >
    <path
      fill="#1565C0"
      d="M18.7,13.767l0.005,0.002C18.809,13.326,19.187,13,19.66,13h13.472c0.017,0,0.034-0.007,0.051-0.006C32.896,8.215,28.887,6,25.35,6H11.878c-0.474,0-0.852,0.335-0.955,0.777l-0.005-0.002L5.029,33.813l0.013,0.001c-0.014,0.064-0.039,0.125-0.039,0.194c0,0.553,0.447,0.991,1,0.991h8.071L18.7,13.767z"
    ></path>
    <path
      fill="#039BE5"
      d="M33.183,12.994c0.053,0.876-0.005,1.829-0.229,2.882c-1.281,5.995-5.912,9.115-11.635,9.115c0,0-3.47,0-4.313,0c-0.521,0-0.767,0.306-0.88,0.54l-1.74,8.049l-0.305,1.429h-0.006l-1.263,5.796l0.013,0.001c-0.014,0.064-0.039,0.125-0.039,0.194c0,0.553,0.447,1,1,1h7.333l0.013-0.01c0.472-0.007,0.847-0.344,0.945-0.788l0.018-0.015l1.812-8.416c0,0,0.126-0.803,0.97-0.803s4.178,0,4.178,0c5.723,0,10.401-3.106,11.683-9.102C42.18,16.106,37.358,13.019,33.183,12.994z"
    ></path>
    <path
      fill="#283593"
      d="M19.66,13c-0.474,0-0.852,0.326-0.955,0.769L18.7,13.767l-2.575,11.765c0.113-0.234,0.359-0.54,0.88-0.54c0.844,0,4.235,0,4.235,0c5.723,0,10.432-3.12,11.713-9.115c0.225-1.053,0.282-2.006,0.229-2.882C33.166,12.993,33.148,13,33.132,13H19.66z"
    ></path>
  </svg>
);

const Visa = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="40"
    height="40"
    viewBox="0 0 48 48"
  >
    <path
      fill="#1565C0"
      d="M45,35c0,2.209-1.791,4-4,4H7c-2.209,0-4-1.791-4-4V13c0-2.209,1.791-4,4-4h34c2.209,0,4,1.791,4,4V35z"
    ></path>
    <path
      fill="#FFF"
      d="M15.186 19l-2.626 7.832c0 0-.667-3.313-.733-3.729-1.495-3.411-3.701-3.221-3.701-3.221L10.726 30v-.002h3.161L18.258 19H15.186zM17.689 30L20.56 30 22.296 19 19.389 19zM38.008 19h-3.021l-4.71 11h2.852l.588-1.571h3.596L37.619 30h2.613L38.008 19zM34.513 26.328l1.563-4.157.818 4.157H34.513zM26.369 22.206c0-.606.498-1.057 1.926-1.057.928 0 1.991.674 1.991.674l.466-2.309c0 0-1.358-.515-2.691-.515-3.019 0-4.576 1.444-4.576 3.272 0 3.306 3.979 2.853 3.979 4.551 0 .291-.231.964-1.888.964-1.662 0-2.759-.609-2.759-.609l-.495 2.216c0 0 1.063.606 3.117.606 2.059 0 4.915-1.54 4.915-3.752C30.354 23.586 26.369 23.394 26.369 22.206z"
    ></path>
    <path
      fill="#FFC107"
      d="M12.212,24.945l-0.966-4.748c0,0-0.437-1.029-1.573-1.029c-1.136,0-4.44,0-4.44,0S10.894,20.84,12.212,24.945z"
    ></path>
  </svg>
);

const MasterCard = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="40"
    height="40"
    viewBox="0 0 48 48"
  >
    <linearGradient
      id="NgmlaCv2fU27PJOuiUvQVa_Sq0VNi1Afgmj_gr1"
      x1="20.375"
      x2="28.748"
      y1="1365.061"
      y2="1394.946"
      gradientTransform="translate(0 -1354)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#00b3ee"></stop>
      <stop offset="1" stop-color="#0082d8"></stop>
    </linearGradient>
    <path
      fill="url(#NgmlaCv2fU27PJOuiUvQVa_Sq0VNi1Afgmj_gr1)"
      d="M43.125,9H4.875C3.287,9,2,10.287,2,11.875v24.25C2,37.713,3.287,39,4.875,39h38.25	C44.713,39,46,37.713,46,36.125v-24.25C46,10.287,44.713,9,43.125,9z"
    ></path>
    <circle cx="17.053" cy="24.053" r="10.053" fill="#cf1928"></circle>
    <linearGradient
      id="NgmlaCv2fU27PJOuiUvQVb_Sq0VNi1Afgmj_gr2"
      x1="20"
      x2="40.107"
      y1="24.053"
      y2="24.053"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#fede00"></stop>
      <stop offset="1" stop-color="#ffd000"></stop>
    </linearGradient>
    <circle
      cx="30.053"
      cy="24.053"
      r="10.053"
      fill="url(#NgmlaCv2fU27PJOuiUvQVb_Sq0VNi1Afgmj_gr2)"
    ></circle>
    <path
      fill="#d97218"
      d="M20,24.053c0,3.072,1.382,5.818,3.553,7.662c2.172-1.844,3.553-4.59,3.553-7.662	s-1.382-5.818-3.553-7.662C21.382,18.235,20,20.981,20,24.053z"
    ></path>
  </svg>
);
